export const DOC_TYPES = [
  { value: "receipt", label: "Receipt" },
  { value: "invoice", label: "Invoice" },
  { value: "purchase_order", label: "Purchase Order" },
  { value: "quote", label: "Quote" },
  { value: "packing_slip", label: "Packing Slip" },
  { value: "delivery_ticket", label: "Delivery Ticket" },
  { value: "order_confirmation", label: "Order Confirmation" },
  { value: "photo", label: "Photo" },
  { value: "return_authorization", label: "Return Authorization" },
  { value: "credit_memo", label: "Credit Memo" },
  { value: "w9", label: "W-9" },
  { value: "insurance_certificate", label: "Insurance Certificate" },
  { value: "lien_waiver", label: "Lien Waiver" },
  { value: "contract", label: "Contract" },
  { value: "other", label: "Other" },
];

export const docTypeLabel = (v) => DOC_TYPES.find((t) => t.value === v)?.label || v;
